// Partial overlay: only QA-provided overrides; everything else falls back to Intl.DisplayNames.
export default [
  {alpha: 'BQ', name: 'Bonaire, Saint Eustache et Saba'},
  {alpha: 'CC', name: 'Îles Cocos (Keeling)'},
  {alpha: 'MF', name: 'Saint-Martin (partie française)'},
  {alpha: 'VN', name: 'Vietnam'},
]
